import { createReduxActionTypes } from '../../../utils/actionFactory';

const SET_CONNNECTIONS = 'SET_CONNNECTIONS';
const RESET_CONNNECTIONS = 'RESET_CONNNECTIONS';
const SET_ACCOUNTS = 'SET_ACCOUNTS';
const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
const SET_COLUMNS = 'SET_COLUMNS';
const UPDATE_FILTERS = 'UPDATE_FILTERS';
const TOOGLE_SWITCH = 'TOOGLE_SWITCH';
const SET_REFRESH = 'SET_REFRESH';

export const actionTypes = createReduxActionTypes('CONNNECTIONS', [
  SET_CONNNECTIONS,
  RESET_CONNNECTIONS,
  SET_ACCOUNTS,
  SET_SELECTED_ACCOUNT,
  UPDATE_FILTERS,
  SET_COLUMNS,
  SET_REFRESH,
  TOOGLE_SWITCH
]);

const DEFAULT_STATE = {
  connections: [],
  selectOptions: [],
  selectedAccount: {},
  productOptions: [],
  showTerminated: false,
  columns: [],
  filters: {
    search: '',
    status: [{ value: 'ACTIVE', label: 'Active' }],
    product: [],
    groupedBy: [
      { label: 'User', value: 'user' },
      { label: 'Product', value: 'sku' }
    ],
    billingStatus: []
  },
  groupByOptions: [
    { label: 'Account', value: 'accountName' },
    { label: 'Status', value: 'status' },
    { label: 'Product', value: 'sku' },
    { label: 'User', value: 'user' }
  ],
  refresh: false
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[SET_CONNNECTIONS]: {
      const { connections, productOptions } = action;
      return {
        ...state,
        connections: [...connections],
        productOptions: [...productOptions]
      };
    }
    case actionTypes[SET_ACCOUNTS]: {
      const { accounts, selectOptions, selectedAccount } = action;
      return { ...state, accounts, selectOptions, selectedAccount };
    }
    case actionTypes[SET_SELECTED_ACCOUNT]: {
      const { selectedAccount } = action;
      return {
        ...state,
        selectedAccount
      };
    }
    case actionTypes[TOOGLE_SWITCH]: {
      const { showTerminated } = action;
      return {
        ...state,
        showTerminated
      };
    }
    case actionTypes[SET_COLUMNS]: {
      return { ...state, columns: [...action.columns] };
    }
    case actionTypes[UPDATE_FILTERS]: {
      const { value, key } = action;
      return {
        ...state,
        filters: {
          ...state.filters,
          [key]: value
        }
      };
    }
    case actionTypes[SET_REFRESH]: {
      const { refresh } = action;
      return {
        ...state,
        refresh
      };
    }
    case actionTypes[RESET_CONNNECTIONS]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  setConnections: ({ connections, productOptions }) => ({
    type: actionTypes[SET_CONNNECTIONS],
    connections,
    productOptions
  }),
  setAccounts: (accounts, selectOptions, selectedAccount) => ({
    type: actionTypes[SET_ACCOUNTS],
    accounts,
    selectOptions,
    selectedAccount
  }),
  toggleShowTerminated: showTerminated => ({
    type: actionTypes[TOOGLE_SWITCH],
    showTerminated
  }),
  setSelectedAccount: selectedAccount => ({
    type: actionTypes[SET_SELECTED_ACCOUNT],
    selectedAccount
  }),
  setColumns: columns => ({
    type: actionTypes[SET_COLUMNS],
    columns
  }),
  updateFilters: ({ value, key }) => ({
    type: actionTypes[UPDATE_FILTERS],
    value,
    key
  }),
  setRefresh: refresh => ({
    type: actionTypes[SET_REFRESH],
    refresh
  }),
  resetConnections: () => ({ type: actionTypes[RESET_CONNNECTIONS] })
};
